import Layout from '@components/layout/Main'
import Background from '@components/image/Background'
import ConstructionSearchpageForm from '@components/search/forms/ConstructionSearchpageForm'

import ViewContextProvider, { VIEWS } from '@context/ViewContext'
import BreadcrumbBar from '@components/breadcrumbs/BreadcrumbBar'
import Sort from '@components/select/Sort'
import State from '@components/select/State'
import View from '@components/select/View'

import AdList from '@components/lists/AdList'
import FAQ from '@components/shared/FAQ'
import FrontpageLinks from '@components/frontpage/FrontpageLinks'

import SeoHeadings from '@pages/search/SearchSeoHeadings'
import Seo from 'src/seo/components/Seo'
import JsonLdSearch from 'src/seo/jsonld/JsonLdSearch'

import dbConnect from 'db/dbConnect'
import listConstructionAds from 'db/repo/listAds/listAdsConstruction'
import sessionCookies from '@utils/sessionCookies'
import useUrlSeo from 'src/seo/server/useUrlSeo'
import useSeoArticle from 'src/seo/components/articles/useSeoArticle'
import locationLdSchema from 'src/seo/jsonld/server/locationLdSchema'
import unslugify from '@utils/links/searchUnslugifyNumericParams'
import makeSearchConstructionLinks from '@components/frontpage/functions/makeSearchConstructionLinks'
import substituteSearchQuery from '@pages/search/functions/substituteSearchQuery'
import constructionFallbackSeo from 'src/seo/server/fallbackSeoConstruction'

import readSeoArticleFile from 'src/seo/server/readSeoArticleFile'

const DEFAULT_HEADINGS = {
    h1: 'Maszyny Budowlane',
    h2: 'Maszyny budowlana na sprzedaż. Sprawdź oferty.',
}

export default function ConstructionSearchpage ({
    cubeLinks,
    footerArticle,
    query, offers, pagination,
    seo, locationObjectLd }) {

    const [seoArticleExcerpt, seoArticleBody] = useSeoArticle(seo.articleFile)

    return (
        <Layout footerArticle={footerArticle}>
            <Seo seo={seo} offers={offers} />
            <JsonLdSearch
                baseUrl="/maszyny-budowlane-sprzedaz"
                buy={false}
                category="Maszyny budowlane"
                locationObjectLd={locationObjectLd}
                offers={offers} />

            <Background
                collapseWhen="form_expands"
                height={320}
                src="/backgrounds/maszyny-budowlane-na-sprzedaz.webp"
                alt="Maszyny budowlane na sprzedaż"
                z={7}>

                <ConstructionSearchpageForm query={query} />

            </Background>

            <ViewContextProvider defaultView={VIEWS.LIST}>
                <SeoHeadings seo={seo} defaultValues={DEFAULT_HEADINGS} />
                {seoArticleExcerpt}

                <BreadcrumbBar>
                    <State />
                    <Sort />
                    <View />
                </BreadcrumbBar>

                <AdList {...{
                    below: seoArticleBody,
                    offers,
                    pagination, }} />
            </ViewContextProvider>

            <FrontpageLinks sections={cubeLinks} />

            <FAQ qa={seo.faqFile} page="construction_searchpage" />
        </Layout>
    )
}

export async function getServerSideProps (context) {
    await dbConnect()

    const query = unslugify(context.query)
    const cookies = sessionCookies(context)
    const { ads, pagination } = await listConstructionAds(query, { cookies })
    const cubeLinks = await makeSearchConstructionLinks(query, '/maszyny-budowlane-sprzedaz')
    return {
        props: {
            cubeLinks,
            footerArticle: await readSeoArticleFile('footer-budowlane', Object.keys(query).length === 0),
            query,
            offers: ads,
            pagination,
            seo: await useUrlSeo({
                baseUrl: '/maszyny-budowlane-sprzedaz',
                defaultSeo: {
                    ...DEFAULT_HEADINGS,
                    title: DEFAULT_HEADINGS.h1,
                    description: DEFAULT_HEADINGS.h2,
                },
                fallbackFunction: constructionFallbackSeo,
                resolvedUrl: context.resolvedUrl,
                query,
                substituteQuery: substituteSearchQuery(query),
            }),
            locationObjectLd: locationLdSchema(query.lokalizacja),
        }
    }
}